import { withInstall } from '@/utils'
import CustomerArea from './src/customerArea.vue'
export default withInstall(CustomerArea)
